// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__TBIrz","milestoneBackground":"milestone_milestoneBackground__Tmg18"};